import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import FaIcon from "../utils/fa_icon";
import { NavLink, useLocation } from "react-router-dom";
import styles from "./sidemenu.module.scss";
import classNames from "classnames";

function matchesPath(pathname: string, target: string) {
  return pathname === target || pathname.startsWith(target + "/");
}

export default function SidemenuLink({
  label,
  href,
  isToggled,
  icon,
  activeMatch,
  activeMatchState,
  dataQa,
}: {
  label: string;
  href: string;
  isToggled: boolean;
  icon: IconDefinition;
  activeMatch?: string[];
  activeMatchState?: { path: string; key: string; value: string };
  dataQa?: string;
}) {
  const location = useLocation();

  const unconditionalActive = activeMatch?.some((path) =>
    matchesPath(location.pathname, path),
  );

  const conditionalActive = activeMatchState
    ? matchesPath(location.pathname, activeMatchState.path) &&
      (location.state as any)?.[activeMatchState.key] === activeMatchState.value
    : false;

  const manuallyActive = unconditionalActive || conditionalActive;

  return (
    <NavLink
      to={href}
      className={({ isActive }) => {
        const active =
          activeMatch || activeMatchState ? manuallyActive : isActive;
        return classNames(styles.sidemenu_link, {
          [styles.active]: active,
          [styles.toggled]: isToggled,
        });
      }}
      data-qa={dataQa ?? label}
      data-guide={`${label} - ${href}`}
      draggable="false"
    >
      <FaIcon icon={icon} className={styles.icon} />
      {!isToggled && label}
    </NavLink>
  );
}
